module.exports = __webpack_public_path__ + "img/info-icon.446a6b49.svg";